export const flattenPages = pages =>
  pages ? pages.reduce((items, page) => [...items, ...page.data], []) : [];

export const flattenQueries = queries =>
  queries.reduce((data, query) => (query.data?.data ? data.concat(query.data.data) : data), []);
